(function() {
  var DataTable = $.fn.dataTable;

  $.extend( true, DataTable.defaults, {
    language: datatable_language_options,
    dom:
      "<'row'<'col-sm-12 col-md-6'i><'col-sm-12 col-md-6'f>>" +
      "<'row'<'col-sm-12'<'table-responsive'tr>>>" +
      "<'row'<'col-sm-12 col-md-5'<'form-inline'l>><'col-sm-12 col-md-7'p>>"
  } );

})();
